import { getInverterBrands } from 'common/api/productsSunwise';

import {
    FETCH_INVERTER_BRANDS,
    FETCH_INVERTER_BRANDS_FAILURE,
    FETCH_INVERTER_BRANDS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    dispatch(actions[FETCH_INVERTER_BRANDS]());

    getInverterBrands()
        .then((response) =>
            dispatch(actions[FETCH_INVERTER_BRANDS_SUCCESS](response.data)),
        )
        .catch((error) =>
            dispatch(
                actions[FETCH_INVERTER_BRANDS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
